/**
 * Phase 1 boot optimizations — each flag defaults OFF in code unless enabled via env.
 * Production/dev stacks enable the validated set in `.env.production` / `.env.development`.
 * Compare with window.__AMAN_BOOT_TELEMETRY.export() after changes.
 */

function envFlag(name) {
  const v = process.env[name];
  return v === '1' || v === 'true';
}

export function isDeferMachineBindingEnabled() {
  return envFlag('REACT_APP_DEFER_MACHINE_BINDING');
}

export function isDeferRoleMaintenanceEnabled() {
  return envFlag('REACT_APP_DEFER_ROLE_MAINTENANCE');
}

export function isSkipLotResyncAfterBootEnabled() {
  return envFlag('REACT_APP_SKIP_LOT_RESYNC_AFTER_BOOT');
}

export function isDeferBackgroundUpdateManagerEnabled() {
  return envFlag('REACT_APP_DEFER_BACKGROUND_UPDATE_MANAGER');
}

export function isDeferDataChangeDetectorEnabled() {
  return envFlag('REACT_APP_DEFER_DATA_CHANGE_DETECTOR');
}

export function isSkipMergedBlobWhenEntityAuthorityEnabled() {
  return envFlag('REACT_APP_SKIP_MERGED_BLOB_WHEN_ENTITY_AUTHORITY');
}

export function isDeferAggregateIndexBackfillEnabled() {
  return envFlag('REACT_APP_DEFER_AGGREGATE_INDEX_BACKFILL');
}

export function isDeferPayloadConsolidationOnBootEnabled() {
  return envFlag('REACT_APP_DEFER_PAYLOAD_CONSOLIDATION_ON_BOOT');
}

/**
 * Virtual POS product grid (react-window) when catalog ≥ threshold (24 cards).
 * Default ON; set REACT_APP_POS_PRODUCT_GRID_VIRTUAL=0|false to disable.
 * Requires measured height on .product-grid-container; scroll lives on
 * .products-grid--virtual (overflow-y:auto — not hidden).
 */
export function isPosProductGridVirtualEnabled() {
  const v = process.env.REACT_APP_POS_PRODUCT_GRID_VIRTUAL;
  if (v === '0' || v === 'false') return false;
  if (v === '1' || v === 'true') return true;
  return true;
}

/**
 * Virtual POS cart lines (react-window List) when basket ≥ 24 lines.
 * Scroll lives on the List host; .cart-items becomes overflow:hidden.
 */
export function isPosCartLinesVirtualEnabled() {
  return envFlag('REACT_APP_POS_CART_LINES_VIRTUAL');
}

export function isDashboardShellGateEnabled() {
  return envFlag('REACT_APP_DASHBOARD_SHELL_GATE');
}

export function isDeferEntityHydrateOnBootEnabled() {
  return envFlag('REACT_APP_DEFER_ENTITY_HYDRATE_ON_BOOT');
}

export function isDeferDashboardNotificationMonitorEnabled() {
  return envFlag('REACT_APP_DEFER_DASHBOARD_NOTIFICATION_MONITOR');
}

/**
 * Skip loading large backup/snapshot KV values during storage open.
 * Keys stay listed; values load on demand or at idle.
 */
export function isDeferBulkyKvHydrationEnabled() {
  return envFlag('REACT_APP_DEFER_BULKY_KV_HYDRATION');
}
